import { render, staticRenderFns } from "./DefaultTime.vue?vue&type=template&id=2aca5c57&scoped=true&"
import script from "./DefaultTime.vue?vue&type=script&lang=js&"
export * from "./DefaultTime.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTime.vue?vue&type=style&index=0&id=2aca5c57&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca5c57",
  null
  
)

export default component.exports